import axios from 'axios';

export const httpClient = axios.create({
  baseURL: `https://api.asemansoleh.com/api/panel/`, //YOUR_API_URL HERE
  // baseURL: `http://localhost:5000/api/panel/`, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
